import { PIXI } from '@colonist/pixi';
export class UIGameToolTipBgView extends PIXI.Container {
    drawToolTipBg() {
        const bg = new PIXI.Graphics();
        bg.beginFill(this.backgroundColor);
        bg.drawRoundedRect(0, 0, this.w, this.h, this.cornerRadius);
        bg.endFill();
        this.addChild(bg);
    }
    constructor(container, w, h, cornerRadius, backgroundColor){
        super();
        this.backgroundColor = backgroundColor;
        this.w = w;
        this.h = h;
        this.cornerRadius = cornerRadius;
        this.drawToolTipBg();
        container.addChildAt(this, 0);
    }
}
